<template>
  <div
      id="regionCheck"
      :class="$style.container"
      v-loading.fullscreen.lock.body="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
    <div style="background-color: #fff;height: auto">
      <header style="position: relative;padding-bottom: 10px;">
      </header>
    </div>

    <div style="height: calc(100% - 50px);">
      <el-container style="width: 384px;float: left;height: 100%;padding:0;">

        <div style="width:384px;">

          <div style="font-size: 18px;color: #000;">

            <el-row style="margin-top: 10px">
              <el-col :span="24" style="overflow: hidden">
                <div style="padding-top: 8px;font-size: 20px;float: left">行政区划管理</div>
                <div style="float: right" class="addBtnSuccess">
                  <el-button type="primary" size="small" icon="el-icon-download" style="" @click="showModalAction">
                    导入导出
                  </el-button>
                  <el-button type="success" size="small" icon="el-icon-plus" @click="xinzeng">新增区划
                  </el-button>
                </div>

              </el-col>

            </el-row>
          </div>


          <div ref="scrollbar" style="border: 1px solid #dedede;margin-top: 13px;width:382px;
                    height: calc(100% - 16px)" @click.stop="">
            <el-row style="border-bottom: 1px solid #dedede;overflow: hidden;height: 100%;
                        border-bottom: none">
              <el-autocomplete
                  v-model="filterText"
                  placeholder="请输入名称进行快速搜索"
                  :fetch-suggestions="search"
                  @select="handleSelect"
                  class="Myinput"
                  style="display: flex;justify-content: center;"
              >

                <div slot-scope="{ item }" style="height: 50px;border-bottom: 1px solid #ededed">
                  <div style="font-size: 14px;color: #555555;height: 22px">{{ item.county_name }}</div>
                  <div style="font-size: 11px;color: #ccc;float: left;height: 18px;">{{ item.city_name }}</div>
                </div>

              </el-autocomplete>


              <el-row class="treeClass"
                      style="width: 158px;float: left;border-right:1px solid #ededed;overflow-y: auto;overflow-x: hidden;height: calc(100% - 41px)">
                <div style="">
                  <el-tree
                      :data="data"
                      :props="defaultProps"
                      @node-click="handleNodeClick"
                      node-key="id"
                      :default-expanded-keys="[province_id, city_id]"
                      :current-node-key="city_id"
                      class="SizeClass"
                      :highlight-current="true"
                      ref="tree"
                  >
                                <span style="font-size: 14px" slot-scope="{ node, data }">
                                    <img src="../../assets/images/tu1.png" alt="" v-if="node.level===1"
                                         style="height: 16.23px;position: relative;top: 3px;">
                                    <img src="../../assets/images/tu2.png" alt="" v-if="node.level===2"
                                         style="height: 16.23px">
                                 <span :class="$style.font">{{ node.label }}</span>
                                </span>
                  </el-tree>
                </div>
              </el-row>


              <el-row class="constrution-tree2"
                      style="width: 224px;float:right;overflow-y: auto;overflow-x: hidden;height: 100%">
                <div style="">
                  <el-tree
                      node-key="id"
                      :default-expanded-keys="[institution_id]"
                      :current-node-key="institution_id"
                      :data="data2"
                      :props="defaultProps"
                      @node-click="handleNodeClick2"
                      class="SizeClass2"
                      :highlight-current="true"
                      ref="tree2"
                  >
                                        <span style="" slot-scope="{ node, data }">
                                            <span style="font-size: 14px;margin-left: -10px">{{ node.label }}</span>
                                        </span>
                  </el-tree>
                </div>
              </el-row>
              <div class="clear" style="clear: both"></div>

            </el-row>
          </div>

        </div>


      </el-container>
      <div style="width: calc(100% - 384px);float: left;overflow: auto;height: 100%">
        <el-main height="100%">
          <div :class="$style.right">
            <div :class="$style.header">
              <div style="height: 31px">
                <div
                    style="padding-top: 8px;color: #4A90E2;font-size: 20px;float: left;height:
                                        30px">
                  <span>{{ institutionObj.province_name }} </span>
                  <span v-if="institutionObj.province_name"> - </span>
                  <span>{{ institutionObj.city_name }}</span>
                  <span v-if="institutionObj.city_name"> - </span>
                  <span>{{ institutionObj.label }}</span>
                </div>

                <div style="float: right;height: 30px" class="addBtnSuccess">
                  <el-button type="warning" size="small" style="" @click="bianji">
                    编辑
                  </el-button>
                </div>

                <div style="float: right;height: 30px;margin-top: 8px;margin-right: 20px">
                </div>
              </div>

            </div>

            <el-row>
              <el-col>
                <div style="border-bottom: 2px dashed rgb(238, 238, 238);">

                </div>
              </el-col>
            </el-row>

            <!-- 地图-->
            <div style="width: 100%;height: 600px">

              <el-amap
                  vid="mapRegioncheck"
                  :center="center"
                  v-if="onoff"
                  zoom="12"
                  class="amap-demo"
                  :plugin="plugin"
              >
                <el-amap-marker :position="institutionObj.markers" :draggable="false"
                                :events="edit_markers.events">
                </el-amap-marker>
              </el-amap>

            </div>
            <!--                        location-->
          </div>
          <div class="message" style="margin-top: 30px;">
            <el-row>
              <el-col style="height: 40px;" :span="12">
                <el-col :span="6" style="font-size: 16px;font-weight: bold">编码</el-col>
                <el-col :span="18" style="color: #4A90E2;font-size: 15px">{{ institutionObj.id }}</el-col>
              </el-col>
              <el-col style="height: 40px;" :span="12">
                <el-col :span="6" style="font-size: 16px;font-weight: bold">名称</el-col>
                <el-col :span="18" style="color: #4A90E2;font-size: 15px">{{ institutionObj.label }}</el-col>
              </el-col>
              <el-col style="height: 40px;" :span="12" v-if="institutionObj.type!=='province'">
                <el-col :span="6" style="font-size: 16px;font-weight: bold">所属省份</el-col>
                <el-col :span="18" style="font-size: 15px;color: #4A4A4A">{{ institutionObj.province_name }}</el-col>
              </el-col>
              <el-col style="height: 40px;" :span="12"
                      v-if="institutionObj.type!=='province' && institutionObj.type!=='city'">
                <el-col :span="6" style="font-size: 16px;font-weight: bold">所属城市</el-col>
                <el-col :span="18" style="font-size: 15px;color: #4A4A4A">{{ institutionObj.city_name }}</el-col>
              </el-col>
              <el-col style="height: 40px;" :span="12">
                <el-col :span="6" style="font-size: 16px;font-weight: bold">中心点坐标</el-col>
                <el-col :span="18" style="font-size: 15px;color: #4A4A4A">{{
                    institutionObj
                        .lng + ' ，' + institutionObj
                        .lat
                  }}
                </el-col>
              </el-col>
              <el-col style="height: 40px;" :span="12">
                <el-col :span="6" style="font-size: 16px;font-weight: bold">启用</el-col>
                <el-col :span="18" style="font-size: 15px;color: #4A4A4A">
                  <el-switch
                      disabled
                      v-model="institutionObj.status"
                      active-value="ACTIVE"
                      inactive-value="INACTIVE"
                      active-color="#13ce66"
                  >
                  </el-switch>
                </el-col>
              </el-col>
            </el-row>
          </div>

        </el-main>

      </div>
    </div>

    <!--导入导出 -->
    <el-dialog
        :visible.sync="dialogVisible"
        width="700px"
        :show-close="false"
        style="vertical-align: center;: #FFF9F3"
        :before-close="closeModal2"
    >
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
          <el-col :span="12">
            <div style="color: #3998F7;padding-top: 8px;font-size: 20px">数据导入与导出
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="danger" size="small" @click="closeModal2">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="subjectList" style="margin-top: 20px;">
          <el-form ref="form" label-width="160px" style="font-size: 14px">
            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载现有数据">
                  <el-button type="primary" size="small" @click="onDownload('array_province','行政区划 - 省份')">
                    下载
                  </el-button>
                  <span style="font-size:14px;color:#585757;margin-left: 11px">
                                    <i class="el-icon-document"></i>行政区划 - 省份.xls
                                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载模板文件">

                  <a style="text-decoration: none;color: #ffff;"
                     class="el-button el-button--primary el-button--small"
                     href="../../../static/省份数据导入模板.xlsx"
                     download="省份数据导入模板.xlsx">下载</a>

                  <span style="font-size:14px;color:#585757;margin-left: 11px">
                                    <i class="el-icon-document"></i>省份数据导入模板.xls
                                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px;">
              <el-col :span="4">
                <el-form-item label="上传数据">
                </el-form-item>
              </el-col>
              <el-col :span="10" style="margin-left:53px;margin-top:3px">
                <div style="border: 1px solid #ededed;height: 30px;">
                  <span style="position: relative;top:8px;left:5px">{{ file }}</span>
                </div>
              </el-col>
              <el-col :span="8" style="margin-top: 3px;padding-left:24px" class="addBtnSuccess primary">
                <el-upload
                    class="upload-demo"
                    ref="uploadProvince"
                    accept=".xlsx,.xls"
                    action=""
                    :file-list="fileList"
                    :show-file-list="false"
                    :on-change="handleChangeProvince"
                    :limit="1"
                    :auto-upload="false"
                >
                  <el-button slot="trigger" type="primary" size="small" style="color: white">选择文件
                  </el-button>
                  <el-button
                      style="margin-left: 10px;"
                      size="small"
                      type="warning"
                      @click="imortDataClick('uploadProvince')"
                  >导入数据
                  </el-button>
                </el-upload>
              </el-col>
            </el-row>


            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载现有数据">
                  <el-button type="primary" size="small" @click="onDownload('array_city','行政区划 - 城市')">
                    下载
                  </el-button>
                  <span style="font-size:14px;color:#585757;margin-left: 11px">
                                    <i class="el-icon-document"></i>行政区划 - 城市.xls
                                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载模板文件">
                  <a style="text-decoration: none;color: #ffff;"
                     class="el-button el-button--primary el-button--small"
                     href="../../../static/城市数据导入模板.xlsx"
                     download="城市数据导入模板.xlsx">下载</a>

                  <span style="font-size:14px;color:#585757;margin-left: 11px">
                                    <i class="el-icon-document"></i>城市数据导入模板.xls
                                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px;">
              <el-col :span="4">
                <el-form-item label="上传数据">
                </el-form-item>
              </el-col>
              <el-col :span="10" style="margin-left:53px;margin-top:3px">
                <div style="border: 1px solid #ededed;height: 30px;">
                  <span style="position: relative;top:8px;left:5px">{{ file2 }}</span>
                </div>
              </el-col>
              <el-col :span="8" style="margin-top: 3px;padding-left:24px" class="addBtnSuccess primary">
                <el-upload
                    class="upload-demo"
                    ref="uploadCity"
                    accept=".xlsx,.xls"
                    action=""
                    :file-list="fileList2"
                    :show-file-list="false"
                    :on-change="handleChangeCity"
                    :limit="1"
                    :auto-upload="false"
                >
                  <el-button slot="trigger" type="primary" size="small" style="color: white">选择文件
                  </el-button>
                  <el-button
                      style="margin-left: 10px;"
                      size="small"
                      type="warning"
                      @click="imortDataClick('uploadCity')"
                  >导入数据
                  </el-button>
                </el-upload>
              </el-col>
            </el-row>


            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载现有数据">
                  <el-button type="primary" size="small" @click="onDownload('array_county','行政区划 - 区县')">
                    下载
                  </el-button>
                  <span style="font-size:14px;color:#585757;margin-left: 11px">
                                    <i class="el-icon-document"></i>行政区划 - 区县.xls
                                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载模板文件">

                  <a style="text-decoration: none;color: #ffff;"
                     class="el-button el-button--primary el-button--small"
                     href="../../../static/区县数据导入模板.xlsx"
                     download="区县数据导入模板.xlsx">下载</a>

                  <span style="font-size:14px;color:#585757;margin-left: 11px">
                                    <i class="el-icon-document"></i>区县数据导入模板.xls
                                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px;">
              <el-col :span="4">
                <el-form-item label="上传数据">
                </el-form-item>
              </el-col>
              <el-col :span="10" style="margin-left:53px;margin-top:3px">
                <div style="border: 1px solid #ededed;height: 30px;">
                  <span style="position: relative;top:8px;left:5px">{{ file3 }}</span>
                </div>
              </el-col>
              <el-col :span="8" style="margin-top: 3px;padding-left:24px" class="addBtnSuccess primary">
                <el-upload
                    class="upload-demo"
                    accept=".xlsx,.xls"
                    ref="uploadRegion"
                    action=""
                    :file-list="fileList3"
                    :show-file-list="false"
                    :on-change="handleChangeRegion"
                    :limit="1"
                    :auto-upload="false"
                >
                  <el-button slot="trigger" type="primary" size="small" style="color: white">选择文件
                  </el-button>
                  <el-button
                      style="margin-left: 10px;"
                      size="small"
                      type="warning"
                      @click="imortDataClick('uploadRegion')"
                  >导入数据
                  </el-button>
                </el-upload>
              </el-col>
            </el-row>


            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="标准行政区划">

                  <el-button type="primary" size="small"
                             @click="onStandardCounty('array_province','provinceListExcel','标准行政区划 - 省份')">下载
                  </el-button>
                  <span style="font-size:14px;color:#585757;margin-left: 5px">
                                        <i class="el-icon-document"></i>省份.xls
                                    </span>

                  <el-button type="primary" size="small"
                             style="margin-left: 30px"
                             @click="onStandardCounty('array_city','cityListExcel','标准行政区划 - 城市')">下载
                  </el-button>
                  <span style="font-size:14px;color:#585757;margin-left: 5px">
                                        <i class="el-icon-document"></i>城市.xls
                                    </span>


                  <el-button type="primary" size="small"
                             style="margin-left: 30px"
                             @click="onStandardCounty('array_county','countyListExcel','标准行政区划 - 区县')">下载
                  </el-button>
                  <span style="font-size:14px;color:#585757;margin-left: 5px">
                                        <i class="el-icon-document"></i>区县.xls
                                    </span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

        </div>
      </div>
    </el-dialog>


    <!--新增/编辑-->
    <el-dialog
        @close="onCloseDialog"
        :visible.sync="dialogVisible2"
        width="850px"
        :show-close="false"
        style="vertical-align: center;: #FFF9F3;margin-top: -100px">
      <div style="margin-top: -40px;">
        <el-row style="padding-bottom: 30px;border-bottom: 2px dotted #e7eaec;padding-top: 10px">
          <el-col :span="12">
            <div style="color: #3998F7;padding-top: 8px;font-size: 20px">{{ isAdd ? '行政区划新增' : '行政区划详情' }}
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="submitAdd">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="clickExtension">
                取消
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div :style="{width:'100%',height:'300px'}">

          <el-amap
              vid="mapcheck2"
              :center="center2"
              :zoom="zoom"
              style="position: relative;height: 400px"
              class="amap-demo"
              :plugin="plugin"
          >
            <el-amap-search-box
                :search-option="searchOption"
                :on-search-result="onSearchResult"
                style="position: absolute;top: 20px;left: 20px"
            ></el-amap-search-box>
            <el-amap-marker :position="markers2" :draggable="true" :events="edit_markers.events">
            </el-amap-marker>
          </el-amap>

        </div>
        <div style="margin-top: 130px;width: 100%;">
          <div style="margin: auto;">
            <el-form label-width="82px"
                     :rules="rules" hide-required-asterisk
                     ref="addForm"
                     :model="formInfo"
                     label-position="left">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="编码" prop="id" class="standard_star ">
                    <el-input :disabled="!isAdd" v-model="formInfo.id"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="名称" class="standard_star " prop="label">
                    <el-input v-model="formInfo.label"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item v-if="formInfo.type!=='province'" label="所属省份" class="standard_star "
                                prop="province_id">

                    <el-select
                        style="width: 100%"
                        v-model="formInfo.province_id"
                        @change="choseProvince(formInfo.province_id)"
                        placeholder="省级地区" clearable>
                      <el-option
                          v-for="item in options_province"
                          :key="item.province_id"
                          :label="item.province_name"
                          :value="item.province_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item v-if="formInfo.type!=='province' && formInfo.type!=='city'" label="所属城市"
                               prop="city_id">
                    <el-select
                        style="width: 100%"
                        v-model="formInfo.city_id"
                        clearable
                        filterable placeholder="请选择">
                      <el-option v-for="item in options_city" :key="item.city_id"
                                 :label="item.city_name"
                                 :value="item.city_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="中心点坐标">
                    <el-input v-model="formInfo.center" disabled></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="启用">
                    <el-switch
                        v-model="formInfo.status"
                        style=""
                        active-value="ACTIVE"
                        inactive-value="INACTIVE"
                        active-color="#13ce66"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>


        </div>

      </div>
    </el-dialog>

    <el-dialog
        :visible.sync="showModal2" :show-close="false"
        width="900px"
        style="margin-top: -20px;"
    >
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">错误提示</span>
          <span>
                        <el-button type="primary" size="small" @click="handleExportData">下载错误信息</el-button>
                    <el-button type="danger" size="small" @click="showModal2=false">关闭</el-button>
                </span>
        </div>
      </div>
      <el-table
          v-if="errorStr === 'province'"
          border
          :data="Mechanism"
          stripe
          height="450px"
          style="width: 100%;margin-top: -20px;"
          header-cell-class-name="headerStyle" :default-sort="{prop: 'date', order: 'descending'}">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
                         width="75"></el-table-column>
        <el-table-column
            prop="province_id"
            label="省份编码"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="province_name"
            label="省份名称"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="province_lng"
            label="省份经度"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="province_lat"
            label="省份纬度"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="zoom"
            label="放大倍数"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="isenable"
            label="是否启用"
            min-width="120px"
            sortable>
        </el-table-column>

        <el-table-column
            fixed="right"
            label="报错信息"
            width="240px">
          <template slot-scope="scope">
            <span style="font-size: 10px;color: red">{{ scope.row.message }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
          v-if="errorStr === 'city'"
          border
          :data="Mechanism"
          stripe
          height="450px"
          style="width: 100%;margin-top: -20px;"
          header-cell-class-name="headerStyle" :default-sort="{prop: 'date', order: 'descending'}">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
                         width="75"></el-table-column>
        <el-table-column
            prop="province_id"
            label="省份编码"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="province_name"
            label="省份名称"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="city_id"
            label="城市编码"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="city_name"
            label="城市名称"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="city_lng"
            label="城市经度"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="city_lat"
            label="城市纬度"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="zoom"
            label="放大倍数"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="isenable"
            label="是否启用"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="报错信息"
            width="240px">
          <template slot-scope="scope">
            <span style="font-size: 10px;color: red">{{ scope.row.message }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
          v-if="errorStr === 'region'"
          border
          :data="Mechanism"
          stripe
          height="450px"
          style="width: 100%;margin-top: -20px;"
          header-cell-class-name="headerStyle" :default-sort="{prop: 'date', order: 'descending'}">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
                         width="75"></el-table-column>
        <el-table-column
            prop="province_id"
            label="省份编码"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="province_name"
            label="省份名称"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="city_id"
            label="城市编码"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="city_name"
            label="城市"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="county_id"
            label="区县编码"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="county_name"
            label="区县名称"
            min-width="120px"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="county_lng"
            label="区县经度"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="county_lat"
            label="区县纬度"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="zoom"
            label="放大倍数"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            prop="isenable"
            label="是否启用"
            min-width="120px"
            sortable>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="报错信息"
            width="240px">
          <template slot-scope="scope">
            <span style="font-size: 10px;color: red">{{ scope.row.message }}</span>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>
  </div>

</template>

<script>
import http from '../../APIService/http'
import tu1 from '../../assets/images/tu1.png'
import tu2 from '../../assets/images/tu2.png'
import {Message} from "element-ui";
import xlsx from "xlsx";
import {export_json_to_excel} from "../../vendor/Export2Excel";

export default {

  data() {
    let self = this
    return {
      onoff: false,
      addTableList: {},
      delateFalse: false,
      tabIndex: 1,
      isAddTable: false,
      tableData: [],
      dataList: [],
      institutionData_hcp: '',
      institutionData_name: '',
      institutionData_location: '',
      optionList: [],
      extendedInfo: [],
      extendedInfo1: [],
      isfalse: false,
      hcp_id: '',
      distributorList: [],
      coordinatesList: [],
      showModal2: false,
      showModal3: false,
      showModal4: false,
      showModal5: false,
      searchStr: "",
      mydiv: 0,
      marginValue: '',
      widthLocation: '',
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      markers2: [121.59996, 31.197646],
      markers3: [],
      centers: [],
      searchOption: {
        citylimit: true
      },
      mapCenter: [121.59996, 31.197646],


      formamap: {
        address: '',
      },
      formapLocation: {
        location_name: '',
        address: '',
        location_id: '',
        status: 'INACTIVE'
      },
      hospitalInstitution_id: '',
      institution_id: '',
      province_id: '',
      city_id: '',
      filterText: '',
      icon: [tu1, tu2],
      // isDisabled:false,


      showAmapDialog: false,
      zoom: 15,
      center: [116.46, 39.92],
      center2: [121.59996, 31.197646],
      plugin: [{
        pName: 'ToolBar',
        position: 'RB',
        // direction:'false',

        events: {
          init(instance) {

          }
        }

      }],
      edit_markers: {
        position: [],
        events: {
          dragend: (e) => {//拖拽结束

            this.getpois([e.lnglat.lng, e.lnglat.lat])
            let geocoder
            AMap.plugin("AMap.Geocoder", function () {
              // 这里通过高德 SDK 完成。
              geocoder = new AMap.Geocoder({
                radius: 1000,
                extensions: "all"
              });
            })
            let selt = this
            geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                if (result && result.regeocode) {
                  console.log(result)
                  // self.formInfo.province_name = result.regeocode.addressComponent.province
                  // self.formInfo.city_name = result.regeocode.addressComponent.city
                  self.formInfo.center = e.lnglat.lng + ' ，' + e.lnglat.lat
                  self.formInfo.lng = e.lnglat.lng
                  self.formInfo.lat = e.lnglat.lat

                  console.log(self.formInfo)
                }
              }
            });
          }
        },
        visible: true,
      },
      kol: false,//KOL
      speaker: false,//专家讲者
      options: [],
      institutionObj: {
        type: '',
        city_id: "",
        city_name: "",
        id: "",
        lat: 0,
        lng: 0,
        province_id: "",
        province_name: "",
        status: "",
        label: "",
        center: "",
        markers: [121.59996, 31.197646]
      },
      Status: {},
      loading: false,
      deptList: [],
      hcpArray: [],
      administrative: [],
      GardeList: [],

      form: {
        name: '',
        title: '',
        position: '',
        input: '',
        input2: ''
      },
      input: '',
      dialog1: false,
      dialog2: false,
      dialogVisible: false,
      dialogVisible2: false,
      data: [],
      data2: [],
      index: "",
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      institution_name: '',
      address: '',
      location_id: '',
      isUpload: false,
      isUpload2: false,
      isUpload3: false,
      isUpload4: false,
      errorStr: "",
      Mechanism: [],
      Mechanism2: [],
      Mechanism3: [],
      Mechanism4: [],
      arr: [],
      arr2: [],
      arr3: [],
      arr4: [],
      Institution: [],
      deriveHcpList: [],
      AGREEMENT_STAGE: [],
      addDeptList: {
        dept_name: '',
        dept_code: '',
        standard_dept: '',
      },
      old_department: '',
      dialogLoaction: false,
      locationDate: [],
      file: '',
      file2: '',
      file3: '',
      isDetail: false,
      isDetail1: false,
      tags: [],
      photoUrl: '',
      uuidAgenda: '',
      categoryAgenda: {},
      photoIdObj: {},
      photoIdArray: [],
      tagText: '',
      imgArray: [],
      photo_id_arr: [],
      editTags: [],
      type: '',
      selectPhotoId: '',
      tags1: [],
      photoUrl1: '',
      uuidAgenda1: '',
      categoryAgenda1: {},
      photoIdObj1: {},
      photoIdArray1: [],
      tagText1: '',
      imgArray1: [],
      photo_id_arr1: [],
      editTags1: [],
      type1: '',
      selectPhotoId1: '',
      fileInfo: {},
      fileTag: '',
      fileTags: [],
      fileTable: [],
      selectFileId: '',
      statistics: {},
      fileTable1: [],
      statistics1: {},
      selectDeptId: '',
      formInfo: {
        id: "",
        status: "ACTIVE",
        label: "",
        city_id: "",
        city_name: "",
        province_id: "",
        province_name: "",
        lat: 0,
        lng: 0,
        center: ""
      },
      markers: [
        {
          position: [121.5273285, 31.21515044],
          events: {
            click: () => {
              alert('click marker');
            },
            dragend: (e) => {
              console.log('---event---: dragend')
              this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
            }
          },
          visible: true,
          draggable: true,
          template: '<span>1</span>',

        }
      ],
      options_province: [],
      options_city: [],
      isAdd: false,
      array_city: [],
      array_province: [],
      array_county: [],
      xlsxData: {
        province: {
          label: [
            '省份编码',
            '省份名称',
            '经度',
            '纬度',
            '放大倍数',
            '是否启用',
            '报错信息'
          ],
          name: [
            'province_id',
            'province_name',
            'province_lng',
            'province_lat',
            'zoom',
            'isenable',
            'message'
          ],
        },
        city: {
          label: [
            '省份编码',
            '省份名称',
            '城市编码',
            '城市名称',
            '经度',
            '纬度',
            '放大倍数',
            '是否启用',
            '报错信息'
          ],
          name: [
            'province_id',
            'province_name',
            'city_id',
            'city_name',
            'city_lng',
            'city_lat',
            'zoom',
            'isenable',
            'message'
          ],
        },
        region: {
          label: [
            '省份编码',
            '省份名称',
            '城市编码',
            '城市名称',
            '区县编码',
            '区县名称',
            '经度',
            '纬度',
            '放大倍数',
            '是否启用',
            '报错信息'
          ],
          name: [
            'province_id',
            'province_name',
            'city_id',
            'city_name',
            'county_id',
            'county_name',
            'county_lng',
            'county_lat',
            'zoom',
            'isenable',
            'message'
          ],
        },
        array_province: {
          label: [
            '省份编码',
            '省份名称',
            '经度',
            '纬度',
            '放大倍数',
            '是否启用'
          ],
          name: [
            'province_id',
            'province_name',
            'lng',
            'lat',
            'zoom',
            'status'
          ],
        },
        array_city: {
          label: [
            '省份编码',
            '省份名称',
            '城市编码',
            '城市名称',
            '经度',
            '纬度',
            '放大倍数',
            '是否启用'
          ],
          name: [
            'province_id',
            'province_name',
            'city_id',
            'city_name',
            'lng',
            'lat',
            'zoom',
            'status'
          ],
        },
        array_county: {
          label: [
            '省份编码',
            '省份名称',
            '城市编码',
            '城市名称',
            '区县编码',
            '区县名称',
            '经度',
            '纬度',
            '放大倍数',
            '是否启用'
          ],
          name: [
            'province_id',
            'province_name',
            'city_id',
            'city_name',
            'county_id',
            'county_name',
            'lng',
            'lat',
            'zoom',
            'status'
          ],
        },
        standardCounty: {
          label: [
            '省份编码',
            '省份',
            '省份经度',
            '省份纬度',
            '城市编码',
            '城市',
            '城市经度',
            '城市纬度',
            '区县编码',
            '区县',
            '区县经度',
            '区县纬度',
          ],
          name: [
            'province_id',
            'province_name',
            'province_lng',
            'province_lat',
            'city_id',
            'city_name',
            'city_lng',
            'city_lat',
            'county_id',
            'county_name',
            'county_lng',
            'county_lat',
          ]
        }
      },
      countyListExcel: [],
      cityListExcel: [],
      provinceListExcel: [],
      rules: {
        province_id: [
          {required: true, message: '所属省份不能为空', trigger: 'select'}
        ],
        // city_id: [
        //   {required: true, message: '所属城市不能为空', trigger: 'select'}
        // ],
        id: [
          {required: true, message: '区县编码不能为空', trigger: 'blur'}
        ],
        label: [
          {required: true, message: '区县名称不能为空', trigger: 'blur'}
        ]
      },
      excelData: [],
      excelData2: [],
      excelData3: [],
      loadingText: '拼命加载中',
      record: [],
      errData: '',

    }
  },

  created() {
    this.province_id = this.$route.query.province_id
    this.city_id = this.$route.query.city_id
    if (!this.province_id) {
      this.province_id = '110000'
    }
    if (!this.city_id ) {
      this.city_id = '110100'
    }

    //获取左侧tree列表
    this.getProvinceAndCityList()
    //获取省份城市
    this.getCityData('province')
    //获取现有的行政辖区
    this.getStandardCounty()
    //获取标准行政辖区
    this.getProvinceCityCounty()
    setTimeout(() => {
      this.onoff = true
    }, 1000)
  },
  watch: {
    'formInfo.city_id': function (n, l) {
      console.log(n)

      if (n) {
        for (let i = 0; i < this.options_city.length; i++) {
          if (n == this.options_city[i].city_id) {
            this.formInfo.city_name = this.options_city[i].city_name
            break;
          }
        }
      } else {
        this.formInfo.city_name = ""
      }

    },
    'formInfo.province_id': function (n, l) {
      console.log(n)

      if (n) {
        for (let i = 0; i < this.options_province.length; i++) {
          if (n == this.options_province[i].province_id) {
            this.formInfo.province_name = this.options_province[i].province_name
            break;
          }
        }
      } else {
        this.formInfo.province_name = ""
      }

    }
  },
  methods: {
    async getProvinceCityCounty() {
      let arr = [
        'PROVINCE',
        'CITY',
        'COUNTY'
      ]
      for (let i = 0; i < arr.length; i++) {
        // let para = "client_id=&tenant_type=MDM&product_id=MDM&tenant_id=" +
        //     this.$store.getters.getUser.tenant_id + "&type=" + arr[i]
        let para = {
          client_id: "com.saasyun.web",
          tenant_type: "MDM",
          product_id: "MDM",
          tenant_id: this.$store.getters.getUser.tenant_id ,
          type:arr[i]
        }
        // await http.post("/yellow_page/getStandardCounty", para).then(res => {
        await http.post("/yp/other/getStandardCounty", para).then(res => {
          console.log(res.data, arr[i])
            debugger;
          if (res.success) {
            if (arr[i] === 'PROVINCE') {
              this.provinceListExcel = res.data
            } else if (arr[i] === 'CITY') {
              this.cityListExcel = res.data
            } else {
              this.countyListExcel = res.data
            }


          }
        }).catch(e => {

        })
      }

    },
    getStandardCounty() {

      try {
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        }
        http.post('/wapi/region/download', data).then(res => {
          this.array_city = res.data.array_city
          this.array_province = res.data.array_province
          this.array_county = res.data.array_county
        }).catch(e => {
          // this.loading = false
        })
      } catch (err) {
        this.loading = false
        loading.close()
        Message.error('当前区县数据加载失败！')
      }
    },
    onStandardCounty(type, key, title) {
      //第一个参数是需要匹配的字段名
      //第二个参数是需要匹配的数据 this[key]
      //第三个参数是标题名
      for (let i = 0; i < this[key].length; i++) {
        this[key][i].status = (this[key][i].status === 'ACTIVE') ? '是' : '否'
      }
      let array = this[key]

      this.handleExportData2(type, array, title)
    },
    //获取省份城市
    choseProvince(province_name) {
      this.formInfo.city_id = ""
      console.log(1)
      this.getCityData(province_name)
    },
    async getCityData(type) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        type: type,
        province_id: type
      }

      await http.post('/wapi/region/getProvinceList', data).then(res => {
        if (res.success == true) {
          if (data.type === 'province') {
            this.options_province = res.data
          } else {
            this.options_city = res.data
          }
        }

      })
    },


    closeModal2() {
      this.excelData = []
      this.excelData2 = []
      this.excelData3 = []
      this.fileList = []
      this.fileList2 = []
      this.fileList3 = []
      this.fileList4 = []
      this.file = ''
      this.file2 = ''
      this.file3 = ''
      this.isUpload = false
      this.isUpload2 = false
      this.isUpload3 = false
      this.isUpload4 = false
      this.dialogVisible = false
      this.$refs.uploadRegion.clearFiles()
      this.$refs.uploadProvince.clearFiles()
      this.$refs.uploadCity.clearFiles()
      console.log(this.fileList)
    },
    showModalAction() {
      this.dialogVisible = true
      this.excelData = []
      this.excelData2 = []
      this.excelData3 = []
    },


    getpois(pois) {

      Message({
        type: 'success',
        message: '坐标已更新'
      })
    },
    xinzeng() {
      this.formInfo = {
        id: "",
        status: "ACTIVE",
        label: "",
        city_id: "",
        city_name: "",
        province_id: "",
        province_name: "",
        lat: 0,
        lng: 0,
        center: ""
      },
          this.dialogVisible2 = true
      this.isAdd = true
    },
    submitAdd() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.baocun()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    baocun() {
      this.loading = true
      try {
        let data = {
          ...this.formInfo,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          isAdd: this.isAdd
        }
        debugger;
        if(this.isAdd)
        {
          data.type ="county"
          if(data.city_id=="")
          {
            data.type ="city"
          }
        }
        http.post('/wapi/region/saveAreaInfo', data).then(res => {
          this.loading = false
          console.log(res)
          if (res.data === '编码不能重复') {
            this.$message.error(res.data);
            this.dialogVisible2 = false
          } else if (res.data === '新增成功') {
            this.province_id = data.province_id
            this.city_id = data.city_id
            this.getEtmsInstituionList('edit')
            this.$refs.tree.setCurrentKey(this.city_id);
            this.dialogVisible2 = false
            this.$message.success(res.data);

          } else if (res.data === '保存成功') {

            this.dialogVisible2 = false
            if (this.formInfo.type === 'province') {
              this.province_id = data.id
              this.getProvinceAndCityList('province')
              this.getEtmsInstituionList()
            } else if (this.formInfo.type === 'city') {
              this.province_id = data.province_id
              this.city_id = data.id
              this.getProvinceAndCityList('city')
              this.getEtmsInstituionList()


            } else {
              this.province_id = data.province_id
              this.city_id = data.city_id
              this.getEtmsInstituionList('edit')
            }

            this.$refs.tree.setCurrentKey(this.city_id);
            this.$message.success(res.data);

          } else {
            this.dialogVisible2 = false
          }

        })
      } catch (err) {
        this.loading = false
        console.log(`error:${err}`)
      }
    },
    bianji() {
      this.dialogVisible2 = true
      this.isAdd = false
      this.formInfo = {
        type: this.institutionObj.type,
        id: this.institutionObj.id,
        label: this.institutionObj.label,
        city_id: this.institutionObj.city_id,
        city_name: this.institutionObj.city_name,
        province_id: this.institutionObj.province_id,
        province_name: this.institutionObj.province_name,
        lat: this.institutionObj.lat,
        lng: this.institutionObj.lng,
        status: this.institutionObj.status,
        center: this.institutionObj.lng + ' ，' + this.institutionObj.lat
      }
      this.markers2 = [this.institutionObj.lng, this.institutionObj.lat]
      this.center2 = [this.institutionObj.lng, this.institutionObj.lat]
    },

    //搜索树形图
    async search(queryString, cb) {
      if (queryString) {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            search: queryString
          }
          await http.post('/wapi/region/searchInstitutionList', data).then(res => {
            if (res.success) {
              cb(res.data);
            } else {
              Message.error(res.message);
            }
          })
        } catch (err) {
          console.log(`error:${err}`)
        }

      } else {
        cb([])
      }
    },
    //选择搜索的树形列表
    handleSelect(item) {
      this.filterText = item.institution_name
      this.institution_id = item.id
      this.getInstitutionInfoAction()

      // this.getInstitutionDeptList()

    },
    //获取选中的详情
    async getInstitutionInfoAction() {
      this.index = ""

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id
      }

      let self = this
      await http.post('/wapi/region/getAreaInfo', data).then(res => {


        if (res.success) {
          let item = res.data[0]
          this.institution_id = item.id
          this.institutionObj.label = item.label
          this.institutionObj.id = item.id
          this.institutionObj.city_id = item.city_id
          this.institutionObj.city_name = item.city_name
          this.institutionObj.province_id = item.province_id
          this.institutionObj.province_name = item.province_name
          this.institutionObj.status = item.status
          this.institutionObj.lat = item.lat ? item.lat : 0
          this.institutionObj.lng = item.lng ? item.lng : 0
          this.institutionObj.markers = [this.institutionObj.lng, this.institutionObj.lat]
          this.center = [this.institutionObj.lng, this.institutionObj.lat]

          //获取城市列表
          this.getCityData(this.institutionObj.province_id)
          let xiabiaoshenfen = 0
          let xiabiaochengshi = 0

          for (var i = 0; i < this.data.length; i++) {
            let obj = this.data[i]
            if (obj.id == res.data[0].province_id) {

              this.province_id = obj.id
              xiabiaoshenfen = i
              for (var j = 0; j < obj.children.length; j++) {
                let obj2 = obj.children[j]
                if (obj2.id == res.data[0].city_id) {
                  this.city_id = obj2.id

                  xiabiaochengshi = j
                }
              }
            }
          }


          this.$nextTick(() => {
            // treeBox 元素的ref   value 绑定的node-key
            this.$refs.tree.setCurrentKey(this.city_id);
            this.getEtmsInstituionListAction()
//
          });

        } else {
          Message.error(res.message);
        }
      })

    },
    //选择后获取右侧列表
    async getEtmsInstituionListAction() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        province_id: this.province_id,
        city_id: this.city_id
      }

      let self = this
      await http.post('/wapi/region/getEtmsAreaListRegion', data).then(res => {

        if (res.success) {
          self.data2 = res.data
          this.$nextTick(() => {
            // treeBox 元素的ref   value 绑定的node-key
            this.$refs.tree2.setCurrentKey(this.institution_id);
          });

        } else {
          Message.error(res.message);
        }
      })

    },
    //获取左侧tree列表
    async getProvinceAndCityList(type = '') {
      this.loading = true
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id
      }
      let self = this
      await http.post('/wapi/region/getProvinceAndCityListRegion', data).then(async res => {
        this.loading = false
        if (res.success) {
          self.data = res.data
          //获取右侧tree列表
          await this.getEtmsInstituionList()
          if (self.data.length > 0) {
            // self.city_id = self.data[0].children[0].id
            if (!type) {
              self.province_id =self.data[0].id
              data = {
                type: 'province',
                id: self.data[0].id,
                label: self.data[0].label,
                city_id: '',
                city_name: '', 
                province_id: '',
                province_name: '',
                lat: self.data[0].lat,
                lng: self.data[0].lng,
                status: self.data[0].status,
              }
              self.getInstitutionInfo2('', data, 'province')
            }
            if (type === 'province') {
              let province_val = self.data.filter(v => v.id === self.province_id)[0]
              data = {
                type: 'province',
                id: province_val.id,
                label: province_val.label,
                city_id: '',
                city_name: '',
                province_id: '',
                province_name: '',
                lat: province_val.lat,
                lng: province_val.lng,
                status: province_val.status,
              }
              self.getInstitutionInfo2('', data, 'province')
            }
            if (type === 'city') {
              let city_val = self.data.filter(v => v.id === self.province_id)[0].children.filter(v=>v.id===self.city_id)[0]
              data = {
                type: 'province',
                id: city_val.id,
                label: city_val.label,
                city_id: '',
                city_name: '',
                province_id: city_val.province_id,
                province_name: city_val.province_name,
                lat: city_val.lat,
                lng: city_val.lng,
                status: city_val.status,
              }
              self.getInstitutionInfo2('', data, 'city')
            }

          }
          if (type === 'city') {
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(self.city_id);
            });
          } else {
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(self.province_id);
            });
          }
          // this.getEtmsInstituionList()

        } else {
          this.loading = false
          Message.error(res.message);
        }
      })

    },
    //获取右侧tree列表
    async getEtmsInstituionList(type) {


      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        province_id: this.province_id,
        city_id: this.city_id
      }
      this.loading = true
      let self = this
      await http.post('/wapi/region/getEtmsAreaListRegion', data).then(res => {
        this.loading = false
        if (res.success) {
          self.data2 = res.data

          if (self.data2.length > 0) {
            let data = {}
            if (type !== 'edit') {
              self.institution_id = res.data[0].id
              data = res.data[0]
            } else {
              data = {
                type: this.formInfo.type,
                id: this.formInfo.id,
                label: this.formInfo.label,
                city_id: this.formInfo.city_id,
                city_name: this.formInfo.city_name,
                province_id: this.formInfo.province_id,
                province_name: this.formInfo.province_name,
                lat: this.formInfo.lat,
                lng: this.formInfo.lng,
                status: this.formInfo.status,
              }
              self.getInstitutionInfo2(self.institution_id, data, data.type)
            }


            // self.getInstitutionInfo2(self.institution_id,data)
          } else {
            this.loading = false
          }
          this.loading = false
        } else {
          this.loading = false
          Message.error(res.message);
        }
      }).catch(e => {
        this.loading = false
      })

    },
    //获取详情
    async getInstitutionInfo2(institution_id, item, type) {
      this.index = ""
      this.institution_id = item.id
      this.institutionObj.type = type
      this.institutionObj.label = item.label
      this.institutionObj.id = item.id
      this.institutionObj.city_id = item.city_id || ''
      this.institutionObj.city_name = item.city_name || ''
      this.institutionObj.province_id = item.province_id || ''
      this.institutionObj.province_name = item.province_name || ''
      this.institutionObj.status = item.status
      this.institutionObj.lat = item.lat ? item.lat : 0
      this.institutionObj.lng = item.lng ? item.lng : 0
      this.institutionObj.markers = [this.institutionObj.lng, this.institutionObj.lat]
      this.center = [this.institutionObj.lng, this.institutionObj.lat]
      //获取省份列表
      if (type === 'province') {
        this.getCityData('province')
      }
      //获取城市列表
      if (type === 'county') {
        this.getCityData(this.institutionObj.province_id)
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        // treeBox 元素的ref  value 绑定的node-key
        this.$refs.tree2.setCurrentKey(this.institution_id);
      });


    },

    //右侧节点点击
    handleNodeClick2(data) {
      this.showContent('county', data)
    },
    //显示内容
    showContent(type, data) {
      this.institution_id = data.id
      this.center = [116.46, 39.92];
      this.centers.length = 0;
      this.mydiv = 0
      this.marginValue = 0
      this.getInstitutionInfo2(this.institution_id, data, type)
    },
    //左侧节点点击
    handleNodeClick(data, node) {

      if (node.level === 1) {
        this.city_id = ''
        this.province_id = data.id
        this.showContent('province', data)
        this.getEtmsInstituionList()

      } else {
        this.city_id = data.id
        this.province_id=data.province_id
        this.showContent('city', data)
        this.getEtmsInstituionList()
      }

    },

    clickExtension() {
      this.dialogVisible2 = false
    },
    async imortDataClick(type) {
      this.record = []
      if (type === 'uploadProvince') {
        if (this.excelData.length === 0) {
          this.$message.error('请选择导入模板！')
          return false;
        }
        this.loading = true
        this.loadingText = `正在导入数据0%(0/${this.excelData.length - 1})`
        this.errData = ''
        this.record = []
        let herder = this.excelData[0]
        let res = await this.importData(herder, this.excelData.slice(1,), 0, 500, this.excelData.length - 1)
        this.loadingText = '拼命加载中'
        this.loading = false
        if (!res) {
          this.$message.error('导入失败')
        } else {
          if (this.record.some(item => item)) {
            this.$message.success('导入成功')
            await this.getProvinceAndCityList()
            if (this.errData.length > 0) {
              this.showModal2 = true
              this.Mechanism = this.errData.slice(0, 100)
              this.errorStr = "province"
            }

          } else {
            this.$message.error('导入失败')
          }
        }
        // if (this.isUpload) {
        //   this.$refs[type].submit()
        //   return
        // }
      } else if (type === 'uploadCity') {
        if (this.excelData2.length === 0) {
          this.$message.error('请选择导入模板！')
          return false;
        }
        this.loading = true
        this.loadingText = `正在导入数据0%(0/${this.excelData2.length - 1})`
        this.errData = ''
        this.record = []
        let herder = this.excelData2[0]
        let res = await this.importData2(herder, this.excelData2.slice(1,), 0, 500, this.excelData2.length - 1)
        this.loadingText = '拼命加载中'
        this.loading = false
        if (!res) {
          this.$message.error('导入失败')
        } else {
          if (this.record.some(item => item)) {
            this.$message.success('导入成功')
            await this.getProvinceAndCityList()

            if (this.errData.length > 0) {
              this.showModal2 = true
              this.Mechanism = this.errData.slice(0, 100)
              this.errorStr = "city"
            }

          } else {
            this.$message.error('导入失败')
          }
        }
        // if (this.isUpload2) {
        //   this.$refs[type].submit()
        //   return
        // }
      } else if (type === 'uploadRegion') {
        if (this.excelData3.length === 0) {
          this.$message.error('请选择导入模板！')
          return false;
        }
        this.loading = true
        this.loadingText = `正在导入数据0%(0/${this.excelData3.length - 1})`
        this.errData = ''
        this.record = []
        let herder = this.excelData3[0]
        let res = await this.importData3(herder, this.excelData3.slice(1,), 0, 500, this.excelData3.length - 1)
        this.loading = false
        this.loadingText = '拼命加载中'
        if (!res) {
          this.$message.error('导入失败')
        } else {
          if (this.record.some(item => item)) {
            this.$message.success('导入成功')
            await this.getProvinceAndCityList()
            if (this.errData.length > 0) {
              this.showModal2 = true
              this.Mechanism = this.errData.slice(0, 100)
              this.errorStr = "region"
            }

          } else {
            this.$message.error('导入失败')
          }
        }
        // if (this.isUpload3) {
        //   this.$refs[type].submit()
        //   return
        // }
      }

      // Message({
      //   showClose: true,
      //   message: '导入模板不能为空',
      //   type: 'error'
      // })


    },
    async importData(herder, excelData = [], page = 0, limit = 1000, size = 0) {

      try {
        if ((page * limit) >= size) {
          return true;
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data: [herder, ...excelData.slice((page * limit), (page + 1) * limit)]
        }

        let response = await http.post("/wapi/excel/importProvince", data)
        if (!response) {
          return false
        }
        if(response.statusCode===502){
          return await this.importData(herder, excelData, page, limit, size)
        }
        this.loadingText = "正在导入数据" + ((((page + 1) * limit) / size) > 1 ? '100%' : ((((page + 1) * limit) / size * 100).toFixed(0) + '% '))
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
        this.loadingText += progressText

        if (response.success) {
          this.record.push(true)
          if (response.data) {
            if (!this.errData) {
              this.errData = []
            }
            this.errData = [...this.errData, ...response.data]

          }
        } else {
          this.record.push(false)
        }
        return await this.importData(herder, excelData, page + 1, limit, size)
      } catch (e) {
        return false
      }
    },
    async importData2(herder, excelData = [], page = 0, limit = 1000, size = 0) {

      try {
        if ((page * limit) >= size) {
          return true;
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data: [herder, ...excelData.slice((page * limit), (page + 1) * limit)]
        }

        let response = await http.post("/wapi/excel/importCity", data)
        if (!response) {
          return false
        }
        if(response.statusCode===502){
          return await this.importData2(herder, excelData, page, limit, size)
        }
        this.loadingText = "正在导入数据" + ((((page + 1) * limit) / size) > 1 ? '100%' : ((((page + 1) * limit) / size * 100).toFixed(0) + '% '))
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
        this.loadingText += progressText

        if (response.success) {
          this.record.push(true)
          if (response.data) {
            if (!this.errData) {
              this.errData = []
            }
            this.errData = [...this.errData, ...response.data]

          }
        } else {
          this.record.push(false)
        }
        return await this.importData2(herder, excelData, page + 1, limit, size)
      } catch (e) {
        return false
      }
    },
    async importData3(herder, excelData = [], page = 0, limit = 1000, size = 0) {

      try {
        if ((page * limit) >= size) {
          return true;
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data: [herder, ...excelData.slice((page * limit), (page + 1) * limit)]
        }

        let response = await http.post("/wapi/excel/importRegion", data)
        if (!response) {
          return false
        }
        if(response.statusCode===502){
          return await this.importData3(herder, excelData, page, limit, size)
        }
        this.loadingText = "正在导入数据" + ((((page + 1) * limit) / size) > 1 ? '100%' : ((((page + 1) * limit) / size * 100).toFixed(0) + '% '))
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
        this.loadingText += progressText

        if (response.success) {
          this.record.push(true)
          if (response.data) {
            if (!this.errData) {
              this.errData = []
            }
            this.errData = [...this.errData, ...response.data]

          }
        } else {
          this.record.push(false)
        }
        return await this.importData3(herder, excelData, page + 1, limit, size)
      } catch (e) {
        return false
      }
    },

    async getParsingFile(fileName) {

      return new Promise(function (resolve, reject) {
        //定义reader，存放文件读取方法
        let reader = new FileReader()

        //启动函数
        reader.readAsBinaryString(fileName)
        //onload文件读取成功
        reader.onload = function (e) {
          //workbook存放excel的所有基本信息
          let workbook = xlsx.read(e.target.result, {type: 'binary'})
          xlsx.onprogress = function (e) {

          }
          //定义sheetList中存放excel表格的sheet表，就是最下方的tab
          let sheetList = workbook.SheetNames

          //存放json数组格式的表格数据
          let resultJson = []
          if (sheetList.length > 1) {
            reject({status: false, message: '模板错误,不能有1个以上sheet'})
          }
          sheetList.forEach(function (y) {
            let worksheet = workbook.Sheets[y]
            resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], {defval: ''})

          });

          if (resultJson.length === 0) {
            resolve({status: true, data: resultJson})
          }
          //取出表头
          let tableHeader = Object.keys(resultJson[0])

          //取出表数据
          let importInfo = resultJson.map((item) => {
            return tableHeader.map(v => item[v])
          })

          importInfo = [tableHeader, ...importInfo]
          resolve({status: true, data: importInfo})
        };
        //文件读取失败
        reader.onerror = function (e) {
          reject({status: false, message: '解析失败'})
        }

      })

    },

    //上传数据
    async handleChangeProvince(file, fileList) {
      this.loading = true
      this.$refs.uploadProvince.clearFiles()
      this.loadingText = '文件解析中'
      let res = await this.getParsingFile(file.raw)

      setTimeout(() => {
        this.loading = false
        this.loadingText = '拼命加载中'
      }, 1000)
      if (!res.status) {
        this.$message.error(res.message)
        this.fileList = []
        return;
      }

      if (res.data.length === 0 || res.data[0].length !== 6 || res.data[0][0].trim() !== '省份编码') {
        this.$message.error('模板错误，请选择正确的模板')
        this.fileList = []
        return false;
      }
      if (res.data.slice(1,).length === 0) {
        this.$message.error('导入数据必须大于0条')
        this.fileList = []
        return false;
      }
      if (fileList.length !== 0 && res) {
        this.file = file.name
      }
      this.excelData = res.data
      //
      // this.file = file.name
      // const nameArr = file.name.split('.')
      // const extension = nameArr[nameArr.length-1] === 'xlsx'
      // const isLt2M = file.size / 1024 / 1024 < 10
      // if (!extension) {
      //   this.file = ''
      //   this.fileList = []
      //   Message({
      //     showClose: true,
      //     message: '上传模板只能是xlsx',
      //     type: 'error'
      //   })
      // }
      // if (!isLt2M) {
      //   this.file = ''
      //   this.fileList = []
      //   Message({
      //     showClose: true,
      //     message: '传模板大小不能超过 10MB',
      //     type: 'error'
      //   })
      // }
      // this.isUpload = true
      //
      // return extension && isLt2M
    },
    async handleChangeCity(file, fileList) {
      this.loading = true
      this.$refs.uploadCity.clearFiles()
      this.loadingText = '文件解析中'
      let res = await this.getParsingFile(file.raw)

      setTimeout(() => {
        this.loading = false
        this.loadingText = '拼命加载中'
      }, 1000)
      if (!res.status) {
        this.$message.error(res.message)
        this.fileList2 = []
        return;
      }

      if (res.data.length === 0 || res.data[0].length !== 8 || res.data[0][0].trim() !== '省份编码') {
        this.$message.error('模板错误，请选择正确的模板')
        this.fileList2 = []
        return false;
      }
      if (res.data.slice(1,).length === 0) {
        this.$message.error('导入数据必须大于0条')
        this.fileList2 = []
        return false;
      }
      if (fileList.length !== 0 && res) {
        this.file2 = file.name
      }
      this.excelData2 = res.data
      //
      // this.file2 = file.name
      // const nameArr = file.name.split('.')
      // const extension = nameArr[nameArr.length-1] === 'xlsx'
      // const isLt2M = file.size / 1024 / 1024 < 10
      // if (!extension) {
      //   this.file2 = ''
      //   this.fileList2 = []
      //   Message({
      //     showClose: true,
      //     message: '上传模板只能是xlsx',
      //     type: 'error'
      //   })
      // }
      // if (!isLt2M) {
      //   this.file2 = ''
      //   this.fileList2 = []
      //   Message({
      //     showClose: true,
      //     message: '传模板大小不能超过 10MB',
      //     type: 'error'
      //   })
      // }
      // this.isUpload2 = true
      //
      // return extension && isLt2M
    },
    async handleChangeRegion(file, fileList) {
      this.loading = true
      this.$refs.uploadRegion.clearFiles()
      this.loadingText = '文件解析中'
      let res = await this.getParsingFile(file.raw)

      setTimeout(() => {
        this.loading = false
        this.loadingText = '拼命加载中'
      }, 1000)
      if (!res.status) {
        this.$message.error(res.message)
        this.fileList3 = []
        return;
      }

      if (res.data.length === 0 || res.data[0].length !== 10 || res.data[0][0].trim() !== '省份编码') {
        this.$message.error('模板错误，请选择正确的模板')
        this.fileList3 = []
        return false;
      }
      if (res.data.slice(1,).length === 0) {
        this.$message.error('导入数据必须大于0条')
        this.fileList3 = []
        return false;
      }
      if (fileList.length !== 0 && res) {
        this.file3 = file.name
      }
      this.excelData3 = res.data
      //
      // this.file3 = file.name
      // const nameArr = file.name.split('.')
      // const extension = nameArr[nameArr.length-1] === 'xlsx'
      // const isLt2M = file.size / 1024 / 1024 < 10
      // if (!extension) {
      //   this.file3 = ''
      //   this.fileList3 = []
      //   Message({
      //     showClose: true,
      //     message: '上传模板只能是xlsx',
      //     type: 'error'
      //   })
      // }
      // if (!isLt2M) {
      //   this.file3 = ''
      //   this.fileList3 = []
      //   Message({
      //     showClose: true,
      //     message: '传模板大小不能超过 10MB',
      //     type: 'error'
      //   })
      // }
      // this.isUpload3 = true
      //
      // return extension && isLt2M
    },
    async handleSuccessProvince(res, file) {

      this.loading = true
      this.file = ''
      if (res.success) {
        try {
//                        var user = this.$store.getters.getUser
          this.file = ''
          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            path: res.data,
          }

          await http.post('/wapi/excel/importProvince', data).then(res => {
            if (res.success) {
              this.closeModal2()

              if (res.data.length == 0) {
                Message({
                  type: 'success',
                  message: '导入成功'
                })
                this.getProvinceAndCityList()
              } else {
                this.getProvinceAndCityList().then(o => {
                  this.showModal2 = true
                  this.Mechanism = [...res.data]
                  this.arr = [...res.data]
                  this.errorStr = "province"
                })
              }
              //重新获取数据
              //重新获取省份城市 以防导入省份
              this.getCityData('province')
              //获取标准行政辖区 + 获取现有的行政辖区
              this.getStandardCounty()
            } else {
              this.fileList = []
              this.loading = false
              Message({
                type: 'error',
                message: '导入失败'
              })
            }
          })
        } catch (err) {
          this.loading = false
          Message.error('导入失败！')
        }
      } else {
        this.loading = false
        Message.error('导入失败！')
      }
    },
    async handleSuccessCity(res, file) {

      this.loading = true
      this.file2 = ''
      if (res.success) {
        try {
//                        var user = this.$store.getters.getUser
          this.file2 = ''
          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            path: res.data,
          }

          await http.post('/wapi/excel/importCity', data).then(res => {
            console.log(res)

            if (res.success) {
              this.closeModal2()

              if (res.data.length == 0) {
                Message({
                  type: 'success',
                  message: '导入成功'
                })
                this.getProvinceAndCityList()
              } else {
                this.getProvinceAndCityList().then(o => {
                  this.showModal2 = true
                  this.Mechanism = [...res.data]
                  this.arr = [...res.data]
                  this.errorStr = "city"
                })


              }
              //重新获取数据
              //重新获取省份城市 以防导入省份
              this.getCityData('province')
              //获取标准行政辖区 + 获取现有的行政辖区
              this.getStandardCounty()
            } else {
              this.fileList2 = []
              this.loading = false
              Message({
                type: 'error',
                message: '导入失败'
              })
            }
          })
        } catch (err) {
          this.loading = false
          Message.error('导入失败！')
        }
      } else {
        this.loading = false
        Message.error('导入失败！')
      }
    },
    async handleSuccessRegion(res, file) {

      this.loading = true
      this.file3 = ''
      if (res.success) {
        try {
//                        var user = this.$store.getters.getUser
          this.file3 = ''
          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            path: res.data,
          }

          await http.post('/wapi/excel/importRegion', data).then(res => {
            if (res.success) {

              this.closeModal2()

              if (res.data.length == 0) {
                Message({
                  type: 'success',
                  message: '导入成功'
                })
                this.getProvinceAndCityList()
              } else {
                this.getProvinceAndCityList().then(o => {
                  this.showModal2 = true
                  this.Mechanism = [...res.data]
                  this.arr = [...res.data]
                  this.errorStr = "region"
                })


              }
              //重新获取数据
              //重新获取省份城市 以防导入省份
              this.getCityData('province')
              //获取标准行政辖区 + 获取现有的行政辖区
              this.getStandardCounty()
            } else {
              this.fileList3 = []
              this.loading = false
              Message({
                type: 'error',
                message: '导入失败'
              })
            }
          })
        } catch (err) {
          this.loading = false
          Message.error('导入失败！')
        }
      } else {
        this.loading = false
        Message.error('导入失败！')
      }
    },
    async onDownload(type, str) {

      this.handleExportData2(type, this[type], str)

    },
    //搜索位置
    onSearchResult(pois) {
      // this.markers2 = [[pois[0].lng, pois[0].lat]]
      // console.log(this.markers2)
      // this.markers2[0] = pois[0].lng
      // this.markers2[1] = pois[0].lat
      this.markers2 = [pois[0].lng, pois[0].lat]
      this.center2 = [pois[0].lng, pois[0].lat]
      this.$forceUpdate()
      let geocoder
      AMap.plugin("AMap.Geocoder", function () {
        // 这里通过高德 SDK 完成。
        geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all"
        });
      })
      let self = this
      geocoder.getAddress([pois[0].lng, pois[0].lat], function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.regeocode) {
            // self.formInfo.province_name = result.regeocode.addressComponent.province
            // self.formInfo.city_name = result.regeocode.addressComponent.city
            self.formInfo.center = pois[0].lng + ',' + pois[0].lat
            self.formInfo.lng = pois[0].lng
            self.formInfo.lat = pois[0].lat
          }
        }
      });
    },
    obj_to_arr(names, data) {
      return data.map(item => {
        let arr = []
        names.forEach(name => {
          arr.push(item[name])
        })
        return arr;
      })
    },
    handleExportData() {
      try {
        this.loading = true
        let tHeader = this.xlsxData[this.errorStr].label
        let names = this.xlsxData[this.errorStr].name
        let data = this.obj_to_arr(names, this.errData)
        this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
        this.downloadErrorExcel(tHeader, data, 0, 20000)
        //错误数据
        this.loading = false
        this.loadingText = '拼命加载中'
      } catch (err) {
        this.loading = false
        this.loadingText = '拼命加载中'
        this.$message.error('下载失败！')
      }
      // try {
      //   import('@/vendor/Export2Excel').then(excel => {
      //     const tHeader = this.xlsxData[this.errorStr].label
      //     const filterVal = this.xlsxData[this.errorStr].name
      //     let arr=[...this.arr]
      //     for (var i = 0; i < arr.length; i++) {
      //       let obj = arr[i].message.join(" ")
      //       arr[i].message = obj
      //     }
      //
      //     const list = arr
      //     const data = this.formatJson(filterVal, list)
      //
      //     excel.export_json_to_excel({
      //       header: tHeader,
      //       data,
      //       filename: '报错信息表',
      //       autoWidth: this.autoWidth
      //     })
      //   })
      //   this.loading = false
      //   this.showModal2=false
      // } catch (err) {
      //   this.loading = false
      //   this.error()
      // }
    },
    downloadErrorExcel(header, data, page = 0, limit = 5000) {
      try {
        if ((page * limit) >= data.length) {
          return true;
        }

        //错误数据
        let tHeader = header
        let tData = data.slice(page * limit, (page + 1) * limit)
        export_json_to_excel({
          header: tHeader,
          data: tData,
          filename: '机构导入错误数据' + (!page ? '' : page)
        })
        this.loadingText = `正在下载错误数据0% (${(page + 1) * limit} / ${data.length})`
        this.downloadErrorExcel(header, data, page + 1, limit)
      } catch (err) {
        this.loading = false
        this.loadingText = '拼命加载中'
        this.$message.error('下载失败！')
      }
    },

    handleExportData2(k, array, title) {
      try {
        import('@/vendor/Export2Excel').then(excel => {
debugger;
          const tHeader = this.xlsxData[k].label
          const filterVal = this.xlsxData[k].name
          let arr = array
          let list = arr
          if (k === 'array_province') {
            list = list.sort((a, b) => parseInt(a.province_id) - parseInt(b.province_id))
          }
          if (k === 'array_city') {
            list = list.sort((a, b) => parseInt(a.province_id) - parseInt(b.province_id)).sort((a, b) => parseInt(a.city_id) - parseInt(b.city_id))
          }
          if (k === 'array_county') {
            list = list.sort((a, b) => parseInt(a.province_id) - parseInt(b.province_id)).sort((a, b) => parseInt(a.city_id) - parseInt(b.city_id)).sort((a, b) => parseInt(a.county_id) - parseInt(b.county_id))
          }

          const data = this.formatJson(filterVal, list)

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: title,
            autoWidth: this.autoWidth
          })
        })
        this.loading = false
      } catch (err) {
        this.loading = false
        this.error()
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    onCloseDialog() {
      this.$refs.addForm.clearValidate()
    }
  },
  updated() {
  },
}


</script>
<style lang="scss" module>
.container {
  /*padding-top: 20px;*/
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
  background: #fff;
  height: 100%;
  box-sizing: border-box;

  .left {
    font-size: 18px;
    margin-top: -40px;
    color: #000000;

    .search {
      width: 97%;
    }

    .type {
      em {
        color: #d98f2f;
        font-size: 14px;

      }
    }

    .first {
      color: #555555;
      font-size: 14px;
    }

    .font {
      margin-left: 10px;
      line-height: 20px;
      font-size: 14px;
      color: #555555;
      position: relative;

    }
  }

  .right {
    margin-top: -20px;
    width: 100%;

    .header {
      width: 100%;
      padding-bottom: 16px;

      margin-top: 8px;
    }

    .body {

      margin-top: 10px;

    }

  }

}
</style>
<style scoped>
.search-box >>> .search-box-wrapper .search-btn {
  display: none;
}

.search-box >>> .search-box-wrapper input {
  width: 20px;
  background: url("../../assets/images/Search_Icon@.png") no-repeat;
  background-size: 20px 20px;
  background-position: right;
  margin-right: 10px;
}

.amap >>> .el-vue-search-box-container {
  width: 100%;
  box-shadow: none;
  border: 1px solid #ededed;
}

.amap >>> .el-form-item__label {
  font-size: 14px;
  color: #000;
  text-align: left;
  font-weight: bold;
}

/*.treeClass >>> .el-tree-node__expand-icon{*/
/*display: none;*/
/*}*/
.Myinput >>> .el-input__inner {
  text-align: center;
  width: 368px;
  height: 30px;
  background-color: #ededed;
  border: #ededed 1px solid;
  margin-top: 5px;
  margin-left: 7px;
}

.Myinput {
  border-bottom: 1px solid #ededed;
  height: 41px;
}

.subjectList >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bolder;
}

.HcpClass >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}

.HcpClass1 >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}

.SizeClass >>> .el-scrollbar__wrap {
  overflow-x: hidden;

}

.SizeClass >>> .el-tree-node:focus > .el-tree-node__content {
  background-color: #d8f6ee;
}

.SizeClass >>> .el-tree-node__content {
  height: 40px;
  line-height: 40px;
}

.SizeClass2 >>> .el-tree-node__content {
  height: 40px;
  line-height: 40px;
  border: none;
}

.arraylist >>> .el-tabs__item {
  font-size: 14px;
}

.arraylist >>> .el-table .cell {
  font-size: 14px;

}

.MapLable >>> .el-form-item__label {
  font-size: 14px;
  text-align: left;
  color: #000;
}

.upload {
  width: 120px;
  height: 120px;
  border: 1px dashed #ccc;
  border-radius: 5px;
  position: relative;
  display: inline-block;
  /*top:-15px;*/
}

.d1 {
  width: 30px;
  height: 1px;
  background-color: #000;
  position: absolute;
  left: 38%;
  top: 50%;
}

.d2 {
  width: 1px;
  height: 30px;
  background-color: #000;
  position: absolute;
  left: 50%;
  top: 38%;
}

.imgInfo {
  display: inline-block;
  margin-left: 10px;
  /*margin-top: 25px;*/
}

.imgInfo >>> .el-tag {
  height: 25px;
  line-height: 25px;
  border-radius: 5px;
}

.photoDetail {
  width: 100%;
  height: 300px;
  background-color: #eaf1fb;
  margin-top: 20px;
  border-radius: 5px;
}

.photoDetail >>> .button {
  width: 50px;
  height: 25px;
  padding: 3px;
  font-size: 8px;

}

.photoDetail >>> .el-upload-dragger {
  width: 300px;
  height: 160px;
}

.photoDetail >>> .el-input__inner {
  width: 300px;
}

.photoDetail >>> .el-tag {
  margin-left: 10px;
  margin-top: 10px;
}

.photoDetail >>> .el-tag .el-tag__close {
  color: white;
}

.photoDetail >>> .el-tag .el-tag__close:hover {
  background-color: #da9ee6;
}

.file >>> .el-input__inner {
  width: 250px;
}
</style>
<style>
.amap-demo {
  width: 100%;
  height: 300px;
  margin-top: 20px;
}

#div1 {

}

#div2 {
  display: none;
}

#div3 {
  display: none;
  margin-left: 15px;
}

#div4Action {
  margin: 0 auto;
  margin-top: 250px;
  text-align: center;
}

.headerStyle1 > div {
  font-size: 14px;
  color: #585757;
  font-weight: bold;
}

.headerStyle1:nth-last-of-type(2) > div {
  color: #4A90E2;
}

/*#div4{*/
/*height:calc(100% - 100px);*/
/*overflow-y: auto;*/
/*}*/
.clearfix:after { /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1; /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
}

.headerStyle > div {
  font-size: 14px;
  color: #585757;
  font-weight: bold;
}

#staff_home .el-table .cell {
  white-space: pre-line;
}

#staff_home .el-table_2_column_15 {
  color: #3b99f7;
}

#staff_home .el-table th > .cell {
  font-weight: bold;
}

.el-table__fixed-header-wrapper .el-table thead {
  color: #909399;
  font-weight: 500;
}

#addTable .el-form-item__error {
  margin-left: 112px;
}

#addTable >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}

#addTableHcp .el-form-item__error {
  margin-left: 112px;
}

#addTableHcp >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}
</style>
<style scoped>
#regionCheck >>> .insitution_star label:after {
  content: '*';
  color: #F56C6C;
  margin-left: 4px;
}

#regionCheck >>> .el-form-item__label {
  font-weight: bold;
  color: #000000;
}

#regionCheck .addBtnSuccess >>> .el-button--success {
  background: #4EC880;
  border-color: #4EC880;
}

#regionCheck .addBtnSuccess >>> .el-button--success:hover {
  background: rgba(78, 200, 128, 0.8);
  border-color: rgba(78, 200, 128, 0.8);
  color: #FFF;
}

#regionCheck .addBtnSuccess >>> .el-button--warning:hover {
  background: #FFB82C;
  border-color: #FFB82C;
  color: #FFF;
}

#regionCheck .addBtnSuccess >>> .el-button--warning {
  background: #ff9901;
  border-color: #ff9901;
}

#regionCheck .addBtnSuccess.primary >>> .el-button--primary {
  background: rgba(126, 211, 33, 1);
  border-color: rgba(126, 211, 33, 1);
}

#regionCheck .addBtnSuccess.primary >>> .el-button--primary:hover {
  background: rgba(126, 211, 33, 0.8);
  border-color: rgba(126, 211, 33, 0.8);
}

#regionCheck >>> .standard_star label:after {
  content: '*';
  color: #F56C6C;
  margin-left: 4px;
}
</style>





// WEBPACK FOOTER //
// src/pages/RegionCheck/RegionCheck.vue